"use strict";
var items = document.querySelectorAll(".shop__item");
var shopCard = document.querySelectorAll(".shop__cards");
var allInput = document.querySelectorAll(".contacts__field", ".form-field");
var form = document.getElementById("form");
console.log(allInput);
console.log(form);
allInput.forEach(function(input) {
    input.addEventListener("input", function() {
        input.style.borderColor = "#bdbdbd";
        if (input.value.length === 0) input.style.borderColor = "#eb5757";
        else input.style.borderColor = "#344f10";
    });
});
form.addEventListener("submit", function(e) {
    e.preventDefault();
    var allFieldFilled = true;
    allInput.forEach(function(input) {
        if (input.value.length === 0) {
            input.style.borderColor = "#eb5757";
            allFieldFilled = false;
        } else input.style.borderColor = "#344f10";
    });
    if (allFieldFilled) {
        form.reset();
        allInput.forEach(function(input) {
            input.style.borderColor = "#bdbdbd";
        });
    }
    return false;
});
items.forEach(function(item, index) {
    item.addEventListener("click", function() {
        items.forEach(function(activeItem) {
            activeItem.classList.remove("shop__item--active");
        });
        item.classList.add("shop__item--active");
        shopCard.forEach(function(card) {
            card.classList.add("hidden");
        });
        shopCard[index].classList.remove("hidden");
    });
});
window.addEventListener("hashchange", function() {
    if (window.location.hash === "#menu") document.body.classList.add("page__body--with-menu");
    else document.body.classList.remove("page__body--with-menu");
});

//# sourceMappingURL=index.7e755280.js.map
